import React, { useEffect, useState, useRef, useCallback } from "react";
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";

import TobNavBar from "../../DashBaord/Top_navbar";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { list as fetchAnalyzerStatus } from "../../../controllers/V1/analyzerStatusController";
import { getPage, formatProjectDate } from "../../../controllers/common";
import moment from "moment";

export default function AnalyzerStatusList() {
  const targetRef = useRef(null);
  const formRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10);
  const [skip, setSkip] = useState(0);
  const [searchTitle, setSearchTitle] = useState("");
  const [filter, setFilter] = useState({});

  const getList = useCallback(async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const condition = {};
      if (filter.game_title?.trim()) {
        condition.game_title = {
          $regex: filter.game_title.trim(),
          $options: "i",
        };
      }
      const options = {
        condition,
        select: {},
        sort: { _id: -1 },
        skip: skip || 0,
        limit: limit || 10,
      };
      const listResponse = await fetchAnalyzerStatus(options);
      if (listResponse.status === true) {
        if (listResponse.result?.length > 0) {
          setListData(listResponse.result);
          setTotalPages(getPage(listResponse.count, limit));
        } else {
          setListData([]);
          setTotalPages(getPage(1, limit));
        }
      } else {
        setListData([]);
      }
    } catch (error) {
      setListData([]);
    } finally {
      setIsLoading(false);
    }
  }, [filter, skip, limit]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * limit);
    targetRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setFilter({ game_title: searchTitle });
    setCurrentPage(1);
    setSkip(0);
  };

  const handleReset = () => {
    setSearchTitle("");
    setFilter({});
    setCurrentPage(1);
    setSkip(0);
    if (formRef.current) {
      formRef.current.reset();
    }
  };

  useEffect(() => {
    getList();
    targetRef.current?.scrollIntoView({ behavior: "smooth" });
    document.title = "U-Winn CRM || Analyser Status";
  }, [getList]);

  return (
    <div className="container-fluid" ref={targetRef}>
      <TobNavBar title="Analyser Status" />
      <div className="inventory_tabs_main_div">
        <form onSubmit={handleSearch} ref={formRef}>
          <div className="row">
            <div className="inventory_all_tabs">
              <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <input
                  type="text"
                  name="game_title"
                  placeholder="Search by game title"
                  className="form-control store_input_field"
                  value={searchTitle}
                  onChange={(e) => setSearchTitle(e.target.value)}
                />
              </div>
              <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="btn btn-danger"
                >
                  Search
                </button>
              </div>
              <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                <button
                  type="button"
                  onClick={handleReset}
                  disabled={isLoading}
                  className="btn btn-light"
                >
                  Reset
                </button>
              </div>
              <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                <button
                  type="button"
                  onClick={getList}
                  disabled={isLoading}
                  className="btn btn-light"
                  title="Refresh"
                >
                  <FontAwesomeIcon icon={faRefresh} />
                </button>
              </div>
            </div>
          </div>
        </form>

        <div id="content-wrapper" className="d-flex flex-column">
          <div className="card shadow mb-4">
            <div className="card-body pt-0">
              <div className="table-responsive">
                <table
                  className="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      <th>Game ID</th>
                      <th>Game Title</th>
                      <th>Start At</th>
                      <th>End At</th>
                      <th>No. of Tickets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <SkeltonList row={5} col={6} />
                    ) : listData?.length > 0 ? (
                      listData.map((item, index) => (
                        <tr key={item._id || index}>
                          <td>{skip + index + 1}</td>
                          <td>{item?.game_id ?? "—"}</td>
                          <td>{item?.game_title ?? "—"}</td>
                          <td>
                            {item?.start_at
                              ? moment(item.start_at).format("DD-MM-YYYY HH:mm:ss")
                              : "—"}
                          </td>
                          <td>
                            {item?.end_at
                              ? moment(item.end_at).format("DD-MM-YYYY HH:mm:ss")
                              : "—"}
                          </td>
                          <td>{item?.no_of_tickets ?? "—"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-3">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
